/**
 * Les prix affichés dans l'appli, en euros. Le serveur reste seul juge du prix
 * facturé (identifiants de prix Stripe) : ces chiffres ne servent qu'à l'affichage.
 */

export const OFFRE_COMPLETE = {
    mensuel: 59,
    annuelParMois: 49,
    annuel: 588,
    economieAnnuelle: 120,
} as const;

export const FORMULE_RETENUE = {
    fondateur: 39,
    normal: 59,
    placesFondateur: 50,
} as const;

/** « 59 € / mois », espaces insécables entre le montant, l'euro et l'unité. */
export function prixParPeriode(montant: number, periode: 'mois' | 'an'): string {
    return `${montant}\u00a0€\u00a0/\u00a0${periode}`;
}
